import { render, staticRenderFns } from "./CouponsBatchTable.vue?vue&type=template&id=cbe8e3a2"
import script from "./CouponsBatchTable.vue?vue&type=script&lang=js"
export * from "./CouponsBatchTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports